import { render, staticRenderFns } from "./DoubleSlider.vue?vue&type=template&id=f929b34e&scoped=true&"
import script from "./DoubleSlider.vue?vue&type=script&lang=js&"
export * from "./DoubleSlider.vue?vue&type=script&lang=js&"
import style0 from "./DoubleSlider.vue?vue&type=style&index=0&id=f929b34e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f929b34e",
  null
  
)

export default component.exports